<template>
  <div v-show="wizard.show" class="bg-white my-3" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
    <div v-if="wizard.current_step > 0" class="d-flex align-items-center justify-content-around mb-3 p-4">
      <div @click="goto_step(2)" :style="wizard.current_step > 1 ? 'cursor: pointer !important;' : ''">
        <div>
          <img src="@/pages/gateways/components/form-wizard/assets/shop.svg" width="64" height="64" :class="wizard.current_step > 1 ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="text-center mt-2">
          <span :style="wizard.current_step > 1 ? 'color: #00bea5' :'color: #d2d2d2'">اطلاعات فروشگاه</span>
        </div>
      </div>
      <div>
        <img src="@/pages/dashboard/userwizard/assets/left-arrow.svg" width="16" height="16" :class="wizard.current_step > 2 ? 'filter_green' : 'filter_gray'">
      </div>
      <div @click="goto_step(3)" :style="wizard.current_step > 2 ? 'cursor: pointer !important;' : ''">
        <div>
          <img src="@/pages/gateways/components/form-wizard/assets/website.svg" width="64" height="64" :class="wizard.current_step > 2 ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="text-center mt-2">
          <span  :style="wizard.current_step > 2 ? 'color: #00bea5' :'color: #d2d2d2'">اطلاعات درگاه</span>
        </div>
      </div>
      <div>
        <img src="@/pages/dashboard/userwizard/assets/left-arrow.svg" width="16" height="16" :class="wizard.current_step > 3 ? 'filter_green' : 'filter_gray'">
      </div>
      <div @click="goto_step(4)" :style="wizard.current_step > 3 ? 'cursor: pointer !important;' : ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" class="bi bi-cash-coin" :class="wizard.current_step > 3 ? 'filter_green' : 'filter_gray'" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"/>
          <path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"/>
          <path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"/>
          <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"/>
        </svg>
        <div class="text-center mt-2">
          <span  :style="wizard.current_step > 3 ? 'color: #00bea5' :'color: #d2d2d2'">نحوه تسویه</span>
        </div>
      </div>
    </div>

    <hr class="custom_hr" v-if="wizard.current_step > 0">

    <div class="p-5">
        <form @submit.prevent="submit" id="gateway_form" class="bg-white">
            <div v-show="wizard.current_step === 2">
                <shop-info-form :wizard="wizard" :form_data="form_data"></shop-info-form>
            </div>
            <div v-show="wizard.current_step === 3">
                <gateway-info-form :wizard="wizard" :form_data="form_data"></gateway-info-form>
            </div>
            <div v-show="wizard.current_step === 4">
                <settlement-type :wizard="wizard" :form_data="form_data"></settlement-type>
            </div>
        </form>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import GatewayInfoForm from "./form-wizard/gateway-info-form";
import ShopInfoForm from "./form-wizard/shop-info-form";
import {i18n} from "@/plugins/i18n";
import { userStatusStr, userStatus } from "@/constants/userStatus";
import { shopType } from "@/constants/ShopType";
import { subcategories } from '@/constants/subcategories'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import SettlementType from "@/pages/gateways/components/form-wizard/settlement-type.vue";

export default {
  components: {
    SettlementType,
    GatewayInfoForm,
    ShopInfoForm,
  },
  props: {
    submit: {
        default: () => {},
        type: Function
    },
    form_data: {
        default() {
            return {}
        },
        type: Object
    },
    wizard: {
        default() {
            return {}
        },
        type: Object
    }
  },
  mounted() {
    this.wizard.show = true;
    this.form_data.site_address = 'https://';
    this.form_data.type = this.shopType.BUSINESS;
    document.getElementById('site_address').disabled = false

    this.$store.dispatch('shebaNumber/fetch')
    .finally(() => {
        Object.keys(this.sheba_numbers).map(key => {
            let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
            this.sheba_numbers[key]['number'] = number
        })
        this.$store.dispatch('address/fetch').finally(() => {
            this.afterDispatch()
        })
    })
    
  },
  data() {
    return {
      shopType,
        userStatus: userStatus,
        subcategories: subcategories,
        wages: [
            {
                id: 0,
                value: this.$t('gateway.wages.from_payer')
            },
            {
                id: 100,
                value: this.$t('gateway.wages.from_me')
            },
            {
                id: 50,
                value: this.$t('gateway.wages.half')
            }
        ]
    };
  },
    watch: {
      'form_data.telephone'(val) {
          console.log(val)
      }
    },
  computed: {
    ...mapGetters("user", [
      "is_authenticated_pending",
      "current_user"
    ]),
    ...mapGetters('address', [
        'addresses'
    ]),
    ...mapGetters('shebaNumber', [
        'sheba_numbers'
    ])
  },
  methods: {
    goto_step(selected_step) {
      $('.pay-card').removeClass('card-selected')
      $("#payment-helper").addClass('card-selected')
      this.form_data.settlement_type = 1
      this.settlement_type = 1
      if (this.wizard.navigable && (this.wizard.current_step > selected_step)) {
        this.wizard.current_step = selected_step;
      }
    },
    afterDispatch() {
      setTimeout(() => {
        $('.kt-selectpicker').selectpicker({
            size: 4,
            liveSearch: true,
            noneResultsText: i18n.t('selectpicker.none_result'),
            selectAllText: i18n.t('selectpicker.select_all'),
            noneSelectedText: i18n.t('selectpicker.nothing_selected')
        })

        document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'));
      }, 500);
    },
    selectChange(event){
        if (event.target.value == 0 || event.target.value == 100)
        this.form_data.merchant_share_percent = event.target.value
    },
  },
};
</script>

<style scoped>
.filter_green {
  filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.filter_gray {
  filter: invert(87%) sepia(1%) saturate(200%) hue-rotate(314deg) brightness(101%) contrast(86%);
}

.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>
